/**
 * Joins vehicle name parts (condition/year/make/model, etc.) into a single space-separated
 * string, skipping any empty/nullish parts.
 */
export const buildVehicleName = (...vehicle: Array<string | number | undefined | null>) => vehicle.filter(Boolean).join(' ');
